export enum MigrationSourceType {
  ESTATE_SMART = 'ESTATE_SMART',
  IS24 = 'IS24',
  EXCEL = 'EXCEL',
}
